import React, { useState, memo, useRef, useEffect } from "react";
import styles from "./index.module.less";
import classNames from "classnames";
import { useDebounceFn, useHover, useEventListener } from "ahooks";
export default memo(function GoodiesCarousel(props) {
  const {
    data: { title, subTitle, CarouselList },
  } = props;
  const [curIndex, setCurIndex] = useState(0);
  const videoRef = useRef();
  const controlRef = useRef();
  const controlHover = useHover(controlRef);
  const { run: change } = useDebounceFn(
    (index) => {
      setCurIndex(index);
    },
    {
      wait: 200,
    }
  );
  function nextVideo() {
    // 如果鼠标移动到tab页面上，进行重复播放
    if (controlHover) {
      videoRef.current.load();
      setTimeout(() => {
        videoRef.current.play();
      }, 200);
      return;
    }
    // 播放完一轮重新播放
    if (curIndex === CarouselList.length - 1) {
      setCurIndex(0);
    } else {
      setCurIndex(curIndex + 1);
    }
  }
  // 监听视频完成，则播放下一个
  useEventListener("ended", nextVideo, { target: videoRef });
  // 监听视频加载，添加类名实现过度效果
  useEventListener(
    "loadstart",
    () => {
      videoRef.current.classList.remove(styles.finish);
      videoRef.current.classList.add(styles.before);
    },
    { target: videoRef }
  );
  useEventListener(
    "canplay",
    () => {
      videoRef.current.classList.remove(styles.before);
      videoRef.current.classList.add(styles.finish);
    },
    { target: videoRef }
  );
  return (
    <div className={styles.content}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subTitle}>{subTitle}</div>
      <header>
        <div className={styles.header} ref={controlRef}>
          {CarouselList.map((i, index) => {
            return (
              <div
                key={index}
                onMouseEnter={() => change(index)}
                className={classNames([
                  styles.tab,
                  curIndex === index ? styles.active : null,
                ])}
              >
                {i.tabName}
              </div>
            );
          })}
        </div>
      </header>

      <div className={styles.carouselContent}>
        <div className={styles.media}>
          <video
            className={classNames([styles.video])}
            muted
            autoPlay
            ref={videoRef}
            preload="metadata"
            src={CarouselList[curIndex].video[0].url}
          />
        </div>
      </div>
    </div>
  );
});
